import * as React from "react";
import { Link } from "gatsby";
import CommonLayout from "./common-layout";
import Comments from "./comments";
import * as postStyles from "../post.module.css";
import "../prismjs.theme.css";

const PostLayout = ({
  title,
  date,
  tags,
  cover,
  children,
  avatar,
  siteUrl,
  slug,
  readingTime,
}) => {
  console.log(readingTime, date);
  return (
    <CommonLayout avatar={avatar}>
      <img src={cover} alt="post cover" className={postStyles.cover} />
      <section className={postStyles.article}>
        <div className={postStyles.articleHeader}>
          <h1 className={postStyles.articleTitle}>{title}</h1>
          <small className={postStyles.date}>{date}</small>
          <small className={postStyles.readingTime}>{readingTime}</small>
          <div className={postStyles.tags}>
            {tags?.map((tag, i) => (
              <Link
                key={i}
                to={`/tags/${tag.replace(".", "").toLowerCase()}`}
                className={postStyles.tag}
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
        {children}
        <section className={postStyles.share}>
          <p>Did you enjoy the article?</p>
          <div className={postStyles.shareLinks}>
            <a
              href={`https://twitter.com/intent/tweet?&text=${title}&url=${
                siteUrl + slug
              }&via=NourdineDev`}
              target="_blank"
              rel="noreferrer"
            >
              <img src="/icons/share/twitter.png" alt="share on twitter"></img>
            </a>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${
                siteUrl + slug
              }`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="/icons/share/facebook.png"
                alt="share on facebook"
              ></img>
            </a>
            <a
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${
                siteUrl + slug
              }`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src="/icons/share/linkedin.png"
                alt="share on linkedin"
              ></img>
            </a>
          </div>
        </section>
        <section className={postStyles.comments}>
          <h2>Comments:</h2>
          <Comments />
        </section>
      </section>
    </CommonLayout>
  );
};

export default PostLayout;
